import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface AddCompanyModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onAddCompany: (company: { name: string; domain: string }) => void;
}

export function AddCompanyModal({
  open,
  onOpenChange,
  onAddCompany,
}: AddCompanyModalProps) {
  const [name, setName] = useState("");
  const [domain, setDomain] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (name.trim() && domain.trim()) {
      onAddCompany({
        name: name.trim(),
        domain: domain.trim(),
      });

      // Reset form and close modal
      setName("");
      setDomain("");
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    setName("");
    setDomain("");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Add Company</DialogTitle>
          <DialogDescription>
            Add a new company to your list. Enter the company name and domain.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="grid gap-4 py-4">
            <div className="grid gap-2">
              <Label htmlFor="company-name">Company Name</Label>
              <Input
                id="company-name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="e.g. Apple"
                autoFocus
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="company-domain">Domain</Label>
              <Input
                id="company-domain"
                value={domain}
                onChange={(e) => setDomain(e.target.value)}
                placeholder="e.g. apple.com"
              />
            </div>
          </div>
          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={!name.trim() || !domain.trim()}
            >
              Add Company
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}